import { Component, OnInit, Injectable } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Quarterly, CTreeNode } from "src/app/models/dashboard/quarterly";
import { DataService } from "src/app/services/data.service";
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-quarterly',
  templateUrl: './quarterly.component.html',
  styleUrls: ['./quarterly.component.scss']
})
@Injectable()
export class QuarterlyComponent implements OnInit {
  cols: any[] = [];
  public currentQuarterly: Quarterly[] = [];
  public historicalQuarterly: TreeNode[] = [];
  public totalCurrentQuarterly: number = 0;
  public paymentOptions: any[] = [];
  public valSelect1: string = null;
  mode: 'Rebate' | 'Patronage' = 'Rebate'; // default mode, can be changed elsewhere


  constructor(private dataService: DataService) { }

  ngOnInit(): void {
    this.dataService.getCurrentQuarterly().subscribe((resp: any) => {
      this.currentQuarterly = resp;
      this.totalCurrentQuarterly = this.currentQuarterly.reduce((sum, x) => sum + x.amount, 0);
    });

    this.dataService.getHistoricalQuarterly().subscribe((resp: any) => {
      this.historicalQuarterly = resp as TreeNode[];
      this.valSelect1 = resp[0]?.payment?.paymentType || null;
    });

    this.paymentOptions = [
      { label: 'ACH', value: 'ACH' },
      { label: 'Check', value: 'Check' }
    ];


    this.cols = [
      { field: 'program', header: 'Batch', width: '50%' },
      { field: 'amount', header: 'Amount', width: '20%' },
      { field: 'date', header: 'Issue Date', width: '20%' }
    ];
  }

  onOptionSelected() {
    this.dataService.UpdateQuarterlyPaymentMethod(this.valSelect1, this.mode).subscribe();
  }

  downloadRebatesExcel() {
    const currentSheet = this.currentQuarterly.map(item => ({
      Vendor: item.name,
      Amount: item.amount,
      'Issue Date': item.date
    }));

    const historicalRows: any[] = [];
    const flattenNodes = (nodes: any[]) => {
      nodes.forEach(node => {
        const row: any = {};
        this.cols.forEach(col => {
          row[col.header] = col.field === 'amount'
            ? this.formatCurrency(node.data[col.field])
            : node.data[col.field];
        });
        historicalRows.push(row);
        if (node.children) {
          flattenNodes(node.children);
        }
      });
    };

    flattenNodes(this.historicalQuarterly);

    this.exportToExcel(
      [
        { name: 'Quarterly Rebates', data: currentSheet },
        { name: 'Historical Rebates', data: historicalRows }
      ],
      'Rebate_Export'
    );
  }
  downloadCurrentRebates() {
    const data = this.currentQuarterly.map(item => ({
      Vendor: item.name,
      Amount: item.amount,
      'Issue Date': item.date
    }));

    this.exportToExcel(
      [{ name: 'Quarterly Rebates', data }],
      'Quarterly_Rebates'
    );
  }

  downloadHistoricalRebates() {
    const historicalRows: any[] = [];

    const flattenNodes = (nodes: any[]) => {
      nodes.forEach(node => {
        const row: any = {};
        this.cols.forEach(col => {
          row[col.header] = col.field === 'amount'
            ? this.formatCurrency(node.data[col.field])
            : node.data[col.field];
        });
        historicalRows.push(row);
        if (node.children) {
          flattenNodes(node.children);
        }
      });
    };

    flattenNodes(this.historicalQuarterly);

    this.exportToExcel(
      [{ name: 'Historical Rebates', data: historicalRows }],
      'Historical_Rebates'
    );
  }


  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  }

  exportToExcel(sheets: { name: string, data: any[] }[], filename: string) {
    const workbook = XLSX.utils.book_new();

    sheets.forEach(sheet => {
      const worksheet = XLSX.utils.json_to_sheet(sheet.data);

      // Format header bold
      const headerKeys = Object.keys(sheet.data[0] || {});
      const range = XLSX.utils.decode_range(worksheet['!ref'] || '');

      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].s = {
          font: { bold: true },
          alignment: { horizontal: 'center' }
        };
      }

      // Format numeric fields as currency if possible
      for (let R = 1; R <= range.e.r; ++R) {
        for (let C = 0; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          const cell = worksheet[cellAddress];
          const header = headerKeys[C];

          if (cell && typeof cell.v === 'string' && cell.v.startsWith('$')) {
            const numericValue = Number(cell.v.replace(/[^0-9.-]+/g, ''));
            if (!isNaN(numericValue)) {
              cell.v = numericValue;
              cell.t = 'n';
              cell.z = '"$"#,##0.00';
            }
          }
        }
      }

      worksheet['!cols'] = headerKeys.map(key => ({
        wch: Math.max(key.length + 2, 14)
      }));

      XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name);
    });

    // Write with styles support (requires xlsx-style variant if needed)
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  }

}
